import { useEffect, useReducer, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../../../../MainComponents/Hooks/useAxios";
import HelmetTags from "../../../../MainComponents/HelmetTags";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function AddEditCourse({ edit }) {
  const [values, setValues] = useState(null);
  const { courseID } = useParams();
  const navigate = useNavigate();

  function reducer(state, action) {
    switch (action.type) {
      case "setErrors": {
        return {
          ...state,
          errors: action.payload,
        };
      }

      case "setSubmitAddEditCourse": {
        return {
          ...state,
          submitAddEditCourse: action.payload,
        };
      }

      default:
        throw Error("Unknown action: " + action.type);
    }
  }

  const [state, dispatch] = useReducer(reducer, {
    submitAddEditCourse: {
      flag: "",
      dependency: false,
      data: {},
    },
  });

  let api = edit
    ? process.env.REACT_APP_ADMIN_EDIT_COURSE_API
    : process.env.REACT_APP_ADMIN_ADD_COURSE_API;
  //!--------- add edit Course -------

  const [CourseAddEditSuccess, CourseAddEditErrors, CourseAddEditLoading] =
    useAxios(
      api,
      "POST",
      state.submitAddEditCourse.flag,
      state.submitAddEditCourse.dependency,
      state.submitAddEditCourse.data,
      true
    );

  //!--------- get the Course info for editing -------

  const [CourseInfo, CourseInfoErrors] = useAxios(
    `${process.env.REACT_APP_ADMIN_GET_COURSE_API}/${courseID}`,
    "GET",
    courseID,
    courseID
  );
  useEffect(() => {
    if (CourseInfo) {
      let temp = CourseInfo.data;
      delete temp.img;
      setValues({
        ...temp,
        visibility: temp.visibility === 1 ? true : false,
      });
    }
  }, [CourseInfo]);

  useEffect(() => {
    //!---add actions ----

    if (CourseAddEditSuccess) {
      navigate(-1);
      reset();
    }
    //! make the dependency false again to listen to the next try to submit
  }, [CourseAddEditSuccess]);

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    reset,
  } = useForm({ mode: "onTouched", values });

  const onSubmit = (data) => {
    const finalData = courseID
      ? {
          ...data,
          id: courseID,
          visibility: +data?.visibility,
          img: data?.img[0] || null,
        }
      : {
          ...data,
          img: data?.img[0] || null,
        };
    dispatch({
      type: "setSubmitAddEditCourse",
      payload: {
        flag: "AddEditCourse",
        dependency: !state.submitAddEditCourse.dependency,
        data: finalData,
      },
    });
  };

  return (
    <section className="flex h-auto w-full flex-col  items-center  dark:bg-dark dark:text-light">
      <HelmetTags title="Courses | Nash Academy"></HelmetTags>

      <div className="form-container my-20 flex w-full flex-col items-center">
        <h2 className="my-20 text-center text-3xl font-semibold">
          Please fill in the information to
          {courseID ? " Edit " : " Add "} the Course
        </h2>

        <form
          encType="multipart/form-data"
          method="post"
          onSubmit={handleSubmit(onSubmit)}
          className="md:max-w-3/4 flex  w-3/4  flex-col items-start justify-center gap-10 rounded-3xl bg-blue-200 p-16 shadow-lg shadow-blue-200/50"
        >
          {/** Name stage filed */}
          <div className="flex w-full items-start justify-between gap-16 md:flex-col md:gap-10 ">
            <div className="name flex w-full flex-col items-start justify-center  gap-2  md:w-full">
              <label htmlFor="name">Name</label>
              <input
                className="signin-inputs w-full pl-4"
                type="text"
                id="name"
                placeholder="Name"
                name="name"
                autoComplete="on"
                {...register("name", {
                  required: true,
                  maxLength: 40,
                  minLength: 3,
                })}
              />
              {errors.name && (
                <p className="w-full  text-[12px] text-blue-900  ">
                  {errors.name.type === "required" &&
                    "Please fill out this field"}
                  {errors.name.type === "maxLength" &&
                    "The maximum number of characters is 40 characters"}
                  {errors.name.type === "minLength" &&
                    "Please write at least 3 characters"}
                </p>
              )}
              {
                //!-------server errors -----

                CourseAddEditErrors &&
                  CourseAddEditErrors?.response?.data?.errors?.name && (
                    <p className="w-full  text-[12px] text-blue-900  ">
                      {CourseAddEditErrors?.response?.data?.errors?.name[0]}
                    </p>
                  )
              }
            </div>
          </div>
          <div className="name flex w-full flex-col items-start justify-center  gap-2  md:w-full">
            <label htmlFor="section">Sections</label>
            <select
              name="section"
              id="section"
              {...register("section", { required: true })}
            >
              <option value="est">Est</option>
              <option value="act">Act</option>
              <option value="dsat">Dsat</option>
            </select>

            {errors.class && (
              <p className="text-xs text-red-500 ">
                {errors.class.class === "required" && "This field is required."}
              </p>
            )}
            {
              //!-------server errors -----

              CourseAddEditErrors &&
                CourseAddEditErrors?.response?.data?.errors?.section && (
                  <p className="w-full text-end text-xs text-red-500  ">
                    {CourseAddEditErrors?.response?.data?.errors?.section[0]}
                  </p>
                )
            }
          </div>

          {edit && (
            <div className="flex w-full items-start justify-between gap-16 md:flex-col md:gap-10 ">
              <div className=" visibility flex w-full flex-col items-end justify-center gap-2 md:w-full">
                <div className="flex w-full items-center justify-end gap-10">
                  <label className="visibility-switch">
                    <input
                      className=""
                      id="visibility"
                      name="visibility"
                      {...register("visibility", {
                        required: false,
                      })}
                      type="checkbox"
                    />
                    <span className="visibility-slider">
                      <svg
                        className="slider-icon"
                        viewBox="0 0 32 32"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        role="presentation"
                      >
                        <path fill="none" d="m4 16.5 8 8 16-16"></path>
                      </svg>
                    </span>
                  </label>
                  <div>
                    <label
                      className="w-full cursor-pointer truncate"
                      htmlFor="visibility"
                    >
                      Visibility
                    </label>
                  </div>
                </div>

                {errors.visibility && (
                  <p className="text-[12px] text-white ">
                    {errors.visibility.type === "required" &&
                      "برجاء ملئ هذا الحقل"}{" "}
                  </p>
                )}
                {
                  //!-------server errors -----

                  CourseAddEditErrors &&
                    CourseAddEditErrors?.response?.data?.errors?.visibility && (
                      <p className="w-full text-end text-[12px] text-white  ">
                        {
                          CourseAddEditErrors?.response?.data?.errors
                            ?.visibility[0]
                        }
                      </p>
                    )
                }
              </div>
            </div>
          )}

          {/** course Image  */}
          <div className="flex w-full flex-col items-end gap-2">
            <label className="w-full" htmlFor="img">
              Upload Course image
            </label>

            <input
              id="img"
              className="signin-inputs   w-full"
              type="file"
              accept="image/jpg, image/jpeg, image/png, image/webp"
              name="img"
              {...register("img", {
                required: values ? false : true,
                validate: (value) => !(value[0]?.size > 5000000),
              })}
            />

            {errors.img && (
              <p className="mt-2 w-full  text-[12px] text-blue-900">
                {errors.img.type === "required" &&
                  "Please add a picture of the class"}
                {errors.img.type === "validate" && "Maximum image size is 5MB"}
              </p>
            )}
            {
              //!-------server errors -----

              CourseAddEditErrors &&
                CourseAddEditErrors?.response?.data?.errors?.img && (
                  <p className="w-full  text-[12px] text-blue-900  ">
                    {CourseAddEditErrors?.response?.data?.errors?.img[0]}
                  </p>
                )
            }
          </div>
          <div className=" flex w-full flex-col items-end justify-center gap-2 ">
            <label className="w-full truncate " htmlFor="description">
              Description
            </label>
            <textarea
              className=" resize-none"
              {...register("description", {
                maxLength: 155,
                minLength: 3,
              })}
              name="description"
              id="description"
              cols="40"
              rows="5"
            ></textarea>
            {errors.description && (
              <p className="text-[12px] text-blue-900 ">
                {errors.description.type === "maxLength" &&
                  "The maximum number of characters is 155 characters"}
                {errors.description.type === "minLength" &&
                  "Please write at least 3 characters"}
              </p>
            )}
            {
              //!-------server errors -----

              CourseAddEditErrors &&
                CourseAddEditErrors?.response?.data?.errors?.description && (
                  <p className="w-full  text-[12px] text-blue-900  ">
                    {
                      CourseAddEditErrors?.response?.data?.errors
                        ?.description[0]
                    }
                  </p>
                )
            }
          </div>
          {/** submit */}

          <button
            disabled={
              !isValid ||
              (CourseAddEditLoading && state.submitAddEditCourse.flag)
            }
            className=" submit mt-6 w-full "
            type="submit"
          >
            {CourseAddEditLoading && state.submitAddEditCourse.flag ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              <p> {courseID ? "Edit Course" : "Add Course"}</p>
            )}
          </button>
        </form>
      </div>
    </section>
  );
}

export default AddEditCourse;
